import { ApiResponse, axiosInstance } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { TAgent } from '../types/agent.type';

/**
 *
 */
export type TGetDetailAgentResponse = ApiResponse<TAgent>;
export interface TGetDetailAgentParams {
  agentId: string;
}

export const getDetailAgent = async (params: TGetDetailAgentParams): Promise<TGetDetailAgentResponse> => {
  const url = `/user/manage/${params.agentId}`;

  return axiosInstance.get(url);
};

/**
 *
 */
export const GET_DETAIL_AGENT_QUERY_KEY = 'get-detail-agent';

export const getDetailAgentQueryOptions = <TData = TAgent>(
  params: TGetDetailAgentParams,
  select?: (data: TGetDetailAgentResponse) => TData
) => {
  return queryOptions({
    queryKey: [GET_DETAIL_AGENT_QUERY_KEY, { agentId: params.agentId }],
    queryFn: () => getDetailAgent(params),
    select,
  });
};

// Overload when select is provided - returns transformed type
export function useGetDetailAgentQuery<TData>(options: {
  params: TGetDetailAgentParams;
  queryConfig?: QueryConfig<typeof getDetailAgentQueryOptions<TData>>;
  select: (data: TGetDetailAgentResponse) => TData;
}): ReturnType<typeof useQuery<TData>>;

// Overload when select is not provided - returns raw API response (even if generic is provided)
export function useGetDetailAgentQuery(options: {
  params: TGetDetailAgentParams;
  queryConfig?: QueryConfig<typeof getDetailAgentQueryOptions<TGetDetailAgentResponse>>;
}): ReturnType<typeof useQuery<TGetDetailAgentResponse>>;

// Implementation
export function useGetDetailAgentQuery<TData = TGetDetailAgentResponse>({
  queryConfig,
  params,
  select,
}: {
  params: TGetDetailAgentParams;
  queryConfig?: QueryConfig<typeof getDetailAgentQueryOptions<TData | TGetDetailAgentResponse>>;
  select?: (data: TGetDetailAgentResponse) => TData;
}) {
  return useQuery({
    ...getDetailAgentQueryOptions(params, select),
    ...queryConfig,
  }) as ReturnType<typeof useQuery<TData extends TGetDetailAgentResponse ? TGetDetailAgentResponse : TData>>;
}
